// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import React from "react"
import { classNames } from "@plasmicapp/react-web"

export function Twitter2Icon(props) {
  const { className, style, title, ...restProps } = props
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 18 18"}
      height={"1em"}
      width={"1em"}
      style={{
        fill: "currentcolor",
        ...(style || {}),
      }}
      className={classNames("plasmic-default__svg", className)}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        d={
          "M16.845 4.51a6.434 6.434 0 01-1.85.506 3.229 3.229 0 001.416-1.78 6.444 6.444 0 01-2.044.78 3.219 3.219 0 00-5.485 2.936A9.138 9.138 0 012.248 3.59a3.217 3.217 0 00.996 4.297 3.207 3.207 0 01-1.458-.402v.04a3.22 3.22 0 002.582 3.156 3.221 3.221 0 01-1.454.056 3.222 3.222 0 003.007 2.235 6.458 6.458 0 01-4.765 1.333A9.111 9.111 0 006.09 15.75c5.92 0 9.158-4.905 9.158-9.158 0-.14-.003-.278-.01-.417a6.54 6.54 0 001.607-1.666z"
        }
        fill={"currentColor"}
      ></path>
    </svg>
  )
}

export default Twitter2Icon
/* prettier-ignore-end */
